import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-succeed",
  "use": "app-icon-succeed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-succeed\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#3DCCA6\" cx=\"8\" cy=\"8\" r=\"8\" /><path d=\"M10.46 6.254a.83.83 0 011.177.002.836.836 0 01.001 1.177L8.1 10.972a.83.83 0 01-1.176-.002.836.836 0 01-.002-1.177l3.539-3.539z\" fill=\"#FFF\" /><path d=\"M4.59 8.768a.832.832 0 010-1.179.83.83 0 011.178 0l2.12 2.12a.832.832 0 01.001 1.18.83.83 0 01-1.18 0l-2.12-2.12z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol